import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const images = [
  "/assets/gallery/wa1.jpeg",
  "/assets/gallery/wa2.jpeg",
  "/assets/gallery/wa3.jpeg",
  "/assets/gallery/wa4.jpeg",
  "/assets/gallery/wa5.jpeg",
];

const HeroSection: React.FC = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleScrollDown = () => {
    const el = document.getElementById("uvod");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100vh", overflow: "hidden" }}>
      {/* Crossfade slides — stacked absolutely, only active one is opaque */}
      {images.map((src, i) => (
        <Box
          key={src}
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${src})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: i === current ? 1 : 0,
            transition: "opacity 1.2s ease-in-out",
            zIndex: 0,
          }}
        />
      ))}

      {/* Dark overlay + text — always visible, z-index above slides */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "rgba(30, 24, 12, 0.52)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
          zIndex: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "12px", md: "14px" },
            letterSpacing: "6px",
            color: "#c8b87a",
            textTransform: "uppercase",
            fontWeight: 300,
            mb: 2,
          }}
        >
          Lipí u Náchoda
        </Typography>

        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontWeight: 700,
            letterSpacing: { xs: "2px", md: "4px" },
            color: "#f5edd8",
            textShadow: "0 2px 24px rgba(0,0,0,0.55)",
            fontSize: { xs: "2rem", sm: "2.8rem", md: "3.8rem" },
            lineHeight: 1.15,
            mb: 2.5,
          }}
        >
          RODINNÝ STATEK VÍTEK
        </Typography>

        <Box sx={{ width: "48px", height: "2px", background: "#c8b87a", mb: 2.5 }} />

        <Typography
          sx={{
            fontSize: { xs: "15px", md: "17px" },
            color: "#d4c8a0",
            letterSpacing: "3px",
            fontWeight: 300,
            textTransform: "uppercase",
            mb: 1,
          }}
        >
          BIO chov masného skotu
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "12px", md: "14px" },
            letterSpacing: "6px",
            color: "#c8b87a",
            textTransform: "uppercase",
            fontWeight: 300,
            mb: 5,
          }}
        >
          od roku 2009
        </Typography>

        {/* Scroll indicator */}
        <Box
          aria-label="scroll down"
          onClick={handleScrollDown}
          sx={{
            position: "absolute",
            bottom: "32px",
            width: "40px",
            height: "40px",
            border: "2px solid rgba(255,255,255,0.45)",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "rgba(255,255,255,0.6)",
            fontSize: "18px",
            transition: "border-color 0.2s, color 0.2s",
            "&:hover": {
              borderColor: "#c8b87a",
              color: "#c8b87a",
            },
          }}
        >
          ↓
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;
